<template>
    <div>
        <div aria-hidden="true" class="pk-loader"></div>
    </div>
</template>

<style lang="scss">
    @layer volver.components {
        .pk-loader {
            width: var(--spacing-48);
            height: var(--spacing-48);
            border-radius: 50%;
            position: relative;
            animation: pk-loader-rotate 1s linear infinite;

            &::before {
                content: '';
                box-sizing: border-box;
                position: absolute;
                inset: 0px;
                border-radius: 50%;
                border: var(--spacing-5) solid var(--color-brand);
                animation: pk-loader-clip 2s linear infinite;
            }

            // Without motion the ring stands still and whole
            @media (prefers-reduced-motion: reduce) {
                animation: none;

                &::before {
                    animation: none;
                }
            }

            @keyframes pk-loader-rotate {
                100% {
                    rotate: 360deg;
                }
            }

            @keyframes pk-loader-clip {
                0% {
                    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
                }

                25% {
                    clip-path: polygon(
                        50% 50%,
                        0 0,
                        100% 0,
                        100% 0,
                        100% 0,
                        100% 0
                    );
                }

                50% {
                    clip-path: polygon(
                        50% 50%,
                        0 0,
                        100% 0,
                        100% 100%,
                        100% 100%,
                        100% 100%
                    );
                }

                75% {
                    clip-path: polygon(
                        50% 50%,
                        0 0,
                        100% 0,
                        100% 100%,
                        0 100%,
                        0 100%
                    );
                }

                100% {
                    clip-path: polygon(
                        50% 50%,
                        0 0,
                        100% 0,
                        100% 100%,
                        0 100%,
                        0 0
                    );
                }
            }
        }
    }
</style>
